import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import { ErrorOutline as ErrorIcon } from '@mui/icons-material';

/**
 * Error Boundary - catches unhandled React rendering errors and shows a recovery UI
 * instead of a blank white screen.
 */
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('ErrorBoundary caught an error:', error, errorInfo);
  }

  handleReload = () => {
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      return (
        <Box
          display="flex"
          flexDirection="column"
          alignItems="center"
          justifyContent="center"
          minHeight="100vh"
          p={3}
          textAlign="center"
          bgcolor="#1a1a2e"
          color="#fff"
        >
          <ErrorIcon sx={{ fontSize: 64, color: '#ff6b6b', mb: 2 }} />
          <Typography variant="h5" gutterBottom>
            Something went wrong
          </Typography>
          <Typography variant="body1" color="grey.400" sx={{ mb: 3, maxWidth: 400 }}>
            The application encountered an unexpected error. Please reload the page to continue.
          </Typography>
          <Button
            variant="contained"
            onClick={this.handleReload}
            sx={{ bgcolor: '#4a90d9', '&:hover': { bgcolor: '#357abd' } }}
          >
            Reload Page
          </Button>
        </Box>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
